import * as Sentry from '@sentry/react';
import { ExpectedError } from '../sentry';

export const assertAdminToken = (token: string) => {
  const parsedToken = JSON.parse(window.atob(token.split('.')[1]));

  if (!parsedToken.isAdmin) {
    Sentry.captureMessage('non_admin_backoffice_login', 'info');
    throw new ExpectedError('User does not have admin privileges.');
  }
};
